import axios from 'axios';

const API_BASE_URL = process.env.VUE_APP_SILVIA_BASE_URL;
axios.defaults.baseURL = API_BASE_URL;
axios.defaults.timeout = 180000; 

axios.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token');

    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (!config.headers['Api-Key']) {
      config.headers['Api-Key'] = process.env.VUE_APP_SILVIA_TOKEN;
    }

    return config;
  },
  error => Promise.reject(error)
);

export async function fetchConversations() {
  try {
    const response = await axios.get('/conversation/list');
    if (response.data && response.data.conversations) {
      return response.data.conversations.map(chat => ({
        conversationName: chat.conversation_name,
        id: chat.id,
        createdAt: chat.createdAt,
        projectId: chat.project_id
      }));
    }
    
    return [];
  } catch (error) {
    console.error('Erro ao buscar conversas:', error);
    return [];
  }
}

export async function fetchConversationHistory(conversationId) {
  try {
    const response = await axios.get('/conversation/history', { params: { conversation_id: conversationId } });
    return response.data.history || [];
  } catch (error) {
    console.error('Erro ao buscar histórico da conversa:', error);
    return [];
  }
}

export async function createConversation(conversationName, projectId) {  
  try {
    const response = await axios.post('/conversation/create', { conversation_name: conversationName, project_id: projectId });
    return response.data;
  } catch (error) {
    console.error('Erro ao criar nova conversa:', error);
  }
}

export async function sendMessage(conversationId, conversationName, question, file = null, intent = 'standard') {
  try {
    const formData = new FormData();
    formData.append('conversation_id', conversationId);     
    formData.append('conversation_name', conversationName);   
    formData.append('question', question);
    formData.append('intent', intent)
    if (file) formData.append('file', file);

    const response = await axios.post('/conversation/message', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao enviar mensagem:', error);
    throw error;
  }
}


export async function deleteConversation(conversationId, projectId) { 
  try {
    const response = await axios.post('/conversation/delete', { conversation_id: conversationId, project_id:projectId   });
    return response.data;
  } catch (error) {
    console.error('Erro ao deletar conversa:', error);
  }
}
export async function sendWikiMessage(
  conversationName,
  question,
  wikiPageName,
  wikiCategory,
  wikiModeOption,
  intent = 'standard',
  file = null
) {
  try {
    const formData = new FormData();
    formData.append('conversation_name', conversationName);
    formData.append('instruction', question);
    formData.append('page_name', wikiPageName);
    formData.append('category', wikiCategory);
    formData.append('intent', intent);
    formData.append('action_type', wikiModeOption);

    if (file) formData.append('file', file);

    const response = await axios.post('/pages/instruction', formData, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        'Api-Key': process.env.VUE_APP_SILVIA_TOKEN,
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;
  } catch (error) {
     console.error('Erro ao enviar mensagem para Wiki:', error.response.data || error.message);
    throw error;
  }
}


export async function renameConversation(oldName, newName, projectId) {
  try {
    const response = await axios.put('/conversation/edit-name', { old_conversation_name: oldName, new_conversation_name: newName, project_id:projectId });
    return response.data;
  } catch (error) {
    console.error('Erro ao renomear conversa', error);
  }
}

export async function getCategory() {
  try {
    const localAxios = axios.create({ baseURL: process.env.VUE_APP_CATEGORIES_URL, headers: { 'X-API-Key': process.env.VUE_APP_MEDIAWIKI_API_KEY } });
    const response = await localAxios.get('list-categories');
    return response.data || { categories: [] };
  } catch (error) {
    console.error('Erro ao buscar categorias:', error);
    return { categories: [] };
  }
}

export async function fetchReport() {
  try {
    const response = await axios.get('/cnpj/master-audit/download',);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar relatório', error);
  }
}

export async function checkCnpjEnrichmentQuota() {
  try {
    const response = await axios.get('/usage-limit/today-usage', {params: { feature: "cnpj_enrichment"}});
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar informações', error);
  }
}